import { Component, OnInit } from '@angular/core';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { PartnerOnboardingMasterDto } from 'src/app/model/partner-onboarding-master-dto';
import { PartnerOnboardingTransactionDto } from 'src/app/model/partner-onboarding-transaction-dto';
import { PartneStagingDto } from 'src/app/model/partne-staging-dto';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { PartnerOnboardingDto } from 'src/app/model/partner-onboarding-dto';
import { Router } from '@angular/router';

@Component({
  selector: 'app-partner-onboarding-create',
  templateUrl: './partner-onboarding-create.component.html',
  styleUrls: ['./partner-onboarding-create.component.css']
})
export class PartnerOnboardingCreateComponent implements OnInit {
  showMessage;
  isLessOrMoreDate;
  loading;
  sourceAndTargetList: PartnerOnboardingMasterDto[];
  partnerTypeList: PartnerOnboardingMasterDto[];
  orderFlowTypeList: PartnerOnboardingMasterDto[];
  refCodeList: PartnerOnboardingMasterDto[];
  partnerNumberList: PartnerOnboardingMasterDto[];
  partnerRefCodeList: PartnerOnboardingMasterDto[];
  partnerOnBoardingTransactionList: PartnerOnboardingTransactionDto[];
  partnerOnBoardingTransaction: PartnerOnboardingTransactionDto;
  sourceModal;
  targetModal;
  public partneStagingDto: PartneStagingDto;
  savedPartner;
  successMessage;
  transactionActiveStatus = true;
  addTransactionValidation;
  transactionMessage;
  saveValidation;
  partnerOnboardingList: PartnerOnboardingDto[];
  partnerOnboardingInitallList: PartnerOnboardingDto[];
  isCheckPartnerNumber;
  isPartnerTransaction = false;
  isPartner = true;
  isEnablePartner = false;
  enablePartnerMesg;
  enablePartnerModel = false;
  enablePartnerChanges = true;
  partnerOnboarindCancelModalPopup;
  partnerActiveStatus = true;
  dusMasterNavigationFlag= false;
enableTag = true;
  constructor(public httpclientService: HttpclientService, public appSettingService: AppSettingService, private router: Router) {
    this.initalLoadingData();
  }

  initalLoadingData() {
    this.partneStagingDto = {
      partnerId: 0, partnerNumber: '-1', partnerName: '', partnerNumberTemp: '',
      processDuplicateIndicator: '', poUniqueIdentifier: '',
      partnerType: '', sapPayerNumbers: '', shippingInstructions: '',
      sharedSecret: '', returnPoUniqueIdentifier: '', orderFlowType: '',
      partnerStatus: 'INITIATED', userIdCreatedBy: parseInt(sessionStorage.getItem('globelUserId')), createDateTime: '',
      userIdLastChangedBy: sessionStorage.getItem('globelUserId'),
      updateDateTime: '', archivedBy: parseInt(sessionStorage.getItem('globelUserId')),
      archivedDateTime: ''
    };


    this.partnerOnBoardingTransactionList = [{

      refCodeId: '-1', refCodeName: '-1', refCodeDesc: '',
      refCodeTypeId: '', fileTrackingHeaderId: '', partnerId: '',
      documentTypeCodeId: '', sourceDeliveryTypeCodeId: '-1',
      targetDeliveryTypeCodeId: '-1', url: '', userIdCreatedBy: '',
      createDateTime: '', userIdLastChangedBy: '', updateDateTime: '',
      destinationPath: '', operationName: '', userId: '',
      password: '', accessTokenURL: '', clientID: '', clientSecret: '', grantType: '',
      rowcheck: false, sourceDeliveryTypeCodeIdRowcheckValidation: false,
      targetDeliveryTypeCodeIdRowcheckValidation: false,
      refCodeDescRowcheckValidation: false, filedEnableStatus: true, archivedBy: '', archivedDateTime: '', rowStatus: 'N'
    }
    ];

    // this.getPartnerOnboardingList();
  }

  ngOnInit() {
    this.getPartnerNumberList();
    this.getSourceAndTargetList();
    this.getPartnerTypeList();
    this.getOrderFlowTypeList();
    this.getReferenceCodeTypeList();
    this.getPartnerRefCodeList();

  }


  partnerNamechange() {
    if (this.partneStagingDto.partnerNumber !== '-1') {
      this.partnerNumberList.forEach(pdto => {
        if (pdto.ediTpId === this.partneStagingDto.partnerNumber) {
          this.partneStagingDto.partnerNumberTemp = pdto.ediTpId;
          this.partneStagingDto.partnerName = pdto.custName;
        }

      });
    }
  }

  addNewRow() {
    this.transactionMessage = '';
    this.checkSaveTransaction();
    console.log('add new roww.. result' + this.addTransactionValidation);
    if (this.addTransactionValidation) {
      this.partnerOnBoardingTransaction = {
        refCodeId: '-1', refCodeName: '-1', refCodeDesc: '',
        refCodeTypeId: '', fileTrackingHeaderId: '', partnerId: '',
        documentTypeCodeId: '', sourceDeliveryTypeCodeId: '-1',
        targetDeliveryTypeCodeId: '-1', url: '', userIdCreatedBy: '',
        createDateTime: '', userIdLastChangedBy: '', updateDateTime: '',
        destinationPath: '', operationName: '', userId: '',
        password: '', accessTokenURL: '', clientID: '', clientSecret: '', grantType: '',
        rowcheck: false, sourceDeliveryTypeCodeIdRowcheckValidation: false,
        targetDeliveryTypeCodeIdRowcheckValidation: false,
        refCodeDescRowcheckValidation: false, filedEnableStatus: true, archivedBy: '', archivedDateTime: '', rowStatus: 'N'
      };
      this.partnerOnBoardingTransactionList.push(this.partnerOnBoardingTransaction);
    } else {
      this.transactionMessage = 'Please check mandatory fields';
    }
  }

  deleteRow(index, selectedItem) {
    this.partnerOnBoardingTransactionList = this.partnerOnBoardingTransactionList.filter(obj => obj !== selectedItem);

  }

  changeRefCode(index) {

    this.partnerRefCodeList.forEach(pdto => {

      if (pdto.refCodeId === this.partnerOnBoardingTransactionList[index].refCodeId) {

        this.partnerOnBoardingTransactionList[index].refCodeDesc = pdto.refCodeDesc;
      }
    });



  }

  changeValidation(index) {
    this.partnerOnBoardingTransactionList[index].rowcheck = true;
    if (this.partnerOnBoardingTransactionList[index].sourceDeliveryTypeCodeId !== '-1' &&
      this.partnerOnBoardingTransactionList[index].targetDeliveryTypeCodeId !== '-1') {
      this.partnerOnBoardingTransactionList[index].filedEnableStatus = false;
    } else {
      this.partnerOnBoardingTransactionList[index].filedEnableStatus = true;
    }

    console.log('row check..' + index);

  }

  cancelPartnerTransaction() {
    // this.getPartnerOnboardingTransactionList();
    this.partnerOnBoardingTransactionList = [];

    this.partnerOnBoardingTransactionList = [{

      refCodeId: '-1', refCodeName: '-1', refCodeDesc: '',
      refCodeTypeId: '', fileTrackingHeaderId: '', partnerId: '',
      documentTypeCodeId: '', sourceDeliveryTypeCodeId: '-1',
      targetDeliveryTypeCodeId: '-1', url: '', userIdCreatedBy: '',
      createDateTime: '', userIdLastChangedBy: '', updateDateTime: '',
      destinationPath: '', operationName: '', userId: '',
      password: '', accessTokenURL: '', clientID: '', clientSecret: '', grantType: '',
      rowcheck: false, sourceDeliveryTypeCodeIdRowcheckValidation: false,
      targetDeliveryTypeCodeIdRowcheckValidation: false,
      refCodeDescRowcheckValidation: false, filedEnableStatus: true, archivedBy: '', archivedDateTime: '', rowStatus: 'N'
    }];

  }

  doSomethingOnTabSelect(event) {
    console.log("on chnage.." + event);
    this.transactionMessage = '';
    if (event === 1) {
      //  this.getPartnerOnboardingTransactionList();
    }

  }

  partnerOnboardingCancel() {
    this.router.navigate(['/partner onboarding']);
  }

  dunsIdCancel() {
    this.router.navigate(['/duns id']);
  }

  goToDustMaster() {
    this.dusMasterNavigationFlag = true;
  }
  pressingCancel() {
    this.partnerOnboarindCancelModalPopup = false;
    this.dusMasterNavigationFlag = false;
  }

  cancelPartner() {
    this.partnerOnboarindCancelModalPopup = true;

  }
  resetPartner() {
    this.initalLoadingData();

  }

  checkPartnerValidation() {
    this.saveValidation = true;
    if (this.partneStagingDto.partnerNumber === '-1' || this.partneStagingDto.partnerName.length === 0 ||
     this.partneStagingDto.sapPayerNumbers === '') {
      this.saveValidation = false;

    }
  }
  getPartnerOnboardingList() {
    this.loading = true;
    this.httpclientService.getPartnerOnboardingList().subscribe(
      data => {
        this.partnerOnboardingList = data;

        this.loading = false;
      }
    );
  }


  checkPartnerNumber(saveStatus) {
    console.log('this.this.partneStagingDto.partnerNumber.length..' + this.partneStagingDto.partnerNumber);
    this.loading = true;

    this.httpclientService.checkPartnerNumber(this.partneStagingDto.partnerNumber, this.partneStagingDto.sapPayerNumbers ).subscribe(
      data => {
        console.log('data.length ..' + data);
        if (data) {
          this.successMessage = 'Partner Number already exists';
          this.loading = false;
        } else {
          this.finalSave(saveStatus);
        }
      }

    );
    console.log('this.isCheckPartnerNumber.length..' + this.isCheckPartnerNumber);
  }


  finalSave(saveStatus) {

    this.httpclientService.savePartnerStaging(this.partneStagingDto).subscribe(
      data => {
        this.partneStagingDto = data;
        if (data !== null) {
          this.savedPartner = data.partnerId;
        }
        this.loading = false;
        this.successMessage = 'Partner is Successfully Saved';
        if (saveStatus) {
          this.isPartner = false;
          this.transactionActiveStatus = false;

          this.isPartnerTransaction = true;
          // this.getPartnerOnboardingTransactionList();
        }
      }, error => {
        this.successMessage = 'Partner Number already exists';
        this.loading = false;

      }
    );
  }

  savePartnerOnboarding(saveStatus) {
    this.loading = true;
    this.successMessage = '';
    this.checkPartnerValidation();
    console.log('final save..' + this.partneStagingDto.partnerNumber);
    console.log('final validation..' + this.saveValidation);
    if (this.saveValidation) {

      this.checkPartnerNumber(saveStatus);
      //       if(this.isCheckPartnerNumber){
      //     this.successMessage = '';

      // } else{
      //   this.successMessage ='Partner Number already exists';
      //   this.loading = false;
      // }
    } else {
      this.successMessage = 'Please check mandatory fields';
      this.loading = false;
    }
  }

  checkSaveTransaction() {
    console.log('this.partnerOnBoardingTransactionList..' + this.partnerOnBoardingTransactionList.length);
    let count = 0;
    this.addTransactionValidation = true;
    this.partnerOnBoardingTransactionList.forEach(pdto => {
      // if (pdto.rowcheck) {
      if (pdto.sourceDeliveryTypeCodeId === '-1' && pdto.targetDeliveryTypeCodeId === '-1') {
        pdto.sourceDeliveryTypeCodeIdRowcheckValidation = false;
        pdto.targetDeliveryTypeCodeIdRowcheckValidation = false;
        pdto.refCodeDescRowcheckValidation = false;
        this.addTransactionValidation = false;
      } else {
        if (pdto.sourceDeliveryTypeCodeId === '-1') {
          pdto.sourceDeliveryTypeCodeIdRowcheckValidation = true;
          this.addTransactionValidation = false;
        } else { pdto.sourceDeliveryTypeCodeIdRowcheckValidation = false; }
        if (pdto.targetDeliveryTypeCodeId === '-1') {
          pdto.targetDeliveryTypeCodeIdRowcheckValidation = true;

          this.addTransactionValidation = false;
        } else { pdto.targetDeliveryTypeCodeIdRowcheckValidation = false; }

        if (pdto.refCodeId === '-1') {
          pdto.refCodeDescRowcheckValidation = true;

          this.addTransactionValidation = false;
        } else { pdto.refCodeDescRowcheckValidation = false; }
        // console.log("count.." + count + '..sourceDeliveryTypeCodeId...' + pdto.sourceDeliveryTypeCodeId);
        // console.log("count.." + count + '..targetDeliveryTypeCodeId...' + pdto.targetDeliveryTypeCodeId);
        // console.log("count.." + count + '..refCodeDesc...' + pdto.refCodeId);
        // console.log("count.." + count + '..addTransactionValidation...' + this.addTransactionValidation);
      }
      //}

      count++;
    });

  }


  savePartnerTransactionStaging(status) {
    this.checkSaveTransaction();
    this.loading = true;
    console.log('this.addTransactionValidation..' + this.addTransactionValidation);
    if (this.addTransactionValidation) {
      this.transactionMessage = '';
      if (this.partnerOnBoardingTransactionList.length === 0) {
        this.transactionMessage = 'Please add atleast one row';
        this.loading = false;

      } else {

        this.httpclientService.savePartnerTransactionStaging(this.savedPartner, sessionStorage.getItem('globelUserId'),
          this.partnerOnBoardingTransactionList).subscribe(
            data => {
              this.transactionMessage = 'Partner transactions are successfully saved';
              // this.partneStagingDto = data;
              // if (data !== null) {
              // this.savedPartner = data.partnerId;
              // }
              this.loading = false;
              if (status) {
                this.isPartnerTransaction = false;
                this.isEnablePartner = true;
              }
            }
          );
      }
    } else {
      this.loading = false;
      this.transactionMessage = 'Please check mandatory fields';
    }
  }


  onchangeEdit(dataValue: Event, itemValue) {
    // this.partneStagingDto[index].changedField = true;
    if (dataValue) {
      this.partneStagingDto.processDuplicateIndicator = '1';
    } else {
      this.partneStagingDto.processDuplicateIndicator = '0';
    }
  }

  // getSourceAndTargetList() {
  //   this.loading = true;
  //   this.httpclientService.getSourceAndTargetList().subscribe(
  //   data => {
  //     this.sourceAndTargetList = data;
  //     this.loading = false;
  //   }
  // );
  //}

  getSourceAndTargetList() {
    this.loading = true;
    if (this.appSettingService.sourceAndTargetGlobelList === null || this.appSettingService.sourceAndTargetGlobelList === undefined) {
      this.httpclientService.getSourceAndTargetList().subscribe(
        data => {
          this.appSettingService.sourceAndTargetGlobelList = data;
          this.sourceAndTargetList = data;
          this.loading = false;
        }
      );

      //  console.log('Partner is null from backend' + this.appSettingService.sourceAndTargetGlobelList);
    } else {
      this.sourceAndTargetList = this.appSettingService.sourceAndTargetGlobelList;
      this.loading = false;
      //  console.log('Partner is not null from frontend' + this.appSettingService.sourceAndTargetGlobelList);
    }
  }

  // getPartnerTypeList() {
  //   this.loading = true;
  //   this.httpclientService.getPartnerTypeList().subscribe(
  //   data => {
  //     this.partnerTypeList = data;
  //     this.loading = false;
  //   }
  // );
  // }

  getPartnerTypeList() {
    this.loading = true;
    if (this.appSettingService.partnerTypeGlobelList === null || this.appSettingService.partnerTypeGlobelList === undefined) {
      this.httpclientService.getPartnerTypeList().subscribe(
        data => {
          this.appSettingService.partnerTypeGlobelList = data;
          this.partnerTypeList = data;
          this.loading = false;
        }
      );

      //  console.log('Partner is null from backend' + this.appSettingService.partnerTypeGlobelList);
    } else {
      this.partnerTypeList = this.appSettingService.partnerTypeGlobelList;
      this.loading = false;
      //  console.log('Partner is not null from frontend' + this.appSettingService.partnerTypeGlobelList);
    }
  }

  // getOrderFlowTypeList() {
  //   this.loading = true;
  //   this.httpclientService.getOrderFlowTypeList().subscribe(
  //   data => {
  //     this.orderFlowTypeList = data;
  //     this.loading = false;
  //   }
  // );
  // }
  getOrderFlowTypeList() {
    this.loading = true;
    if (this.appSettingService.orderFlowTypeGlobelList === null || this.appSettingService.orderFlowTypeGlobelList === undefined) {
      this.httpclientService.getOrderFlowTypeList().subscribe(
        data => {
          this.appSettingService.orderFlowTypeGlobelList = data;
          this.orderFlowTypeList = data;
          this.loading = false;
        }
      );

      //  console.log('Partner is null from backend' + this.appSettingService.orderFlowTypeGlobelList);
    } else {
      this.orderFlowTypeList = this.appSettingService.orderFlowTypeGlobelList;
      this.loading = false;
      //  console.log('Partner is not null from frontend' + this.appSettingService.orderFlowTypeGlobelList);
    }
  }


  // getReferenceCodeTypeList() {
  //   this.loading = true;
  //   this.httpclientService.getReferenceCodeTypeList().subscribe(
  //   data => {
  //     this.refCodeList = data;
  //     this.loading = false;
  //   }
  // );
  // }

  getReferenceCodeTypeList() {
    this.loading = true;
    if (this.appSettingService.refCodeGlobelList === null || this.appSettingService.refCodeGlobelList === undefined) {
      this.httpclientService.getReferenceCodeTypeList().subscribe(
        data => {
          this.appSettingService.refCodeGlobelList = data;
          this.refCodeList = data;
          this.loading = false;
        }
      );

      //  console.log('Partner is null from backend' + this.appSettingService.refCodeGlobelList);
    } else {
      this.refCodeList = this.appSettingService.refCodeGlobelList;
      this.loading = false;
      //  console.log('Partner is not null from frontend' + this.appSettingService.refCodeGlobelList);
    }
  }

  getPartnerRefCodeList() {
    this.loading = true;
    if (this.appSettingService.partnerRefCodeGlobelList === null || this.appSettingService.partnerRefCodeGlobelList === undefined) {
      this.httpclientService.getPartnerRefCodeList().subscribe(
        data => {
          this.appSettingService.refCodeGlobelList = data;
          this.partnerRefCodeList = data;
          this.loading = false;
        }
      );

      //  console.log('Partner is null from backend' + this.appSettingService.refCodeGlobelList);
    } else {
      this.partnerRefCodeList = this.appSettingService.partnerRefCodeGlobelList;
      this.loading = false;
      //  console.log('Partner is not null from frontend' + this.appSettingService.refCodeGlobelList);
    }
  }


  getPartnerNumberList() {
    this.loading = true;
    this.httpclientService.getPartnerNumberList().subscribe(
      data => {
        this.appSettingService.partnerNumberGlobelList = data;
        this.partnerNumberList = data;
        this.loading = false;
      }
    );
  }


  getPartnerOnboardingTransactionList() {
    this.loading = true;
    this.httpclientService.getPartnerOnboardingTransactionList(this.savedPartner).subscribe(
      data => {
        this.partnerOnBoardingTransactionList = data;

        this.partnerOnBoardingTransactionList.forEach(pdto => {
          pdto.sourceDeliveryTypeCodeId = '-1';
          pdto.targetDeliveryTypeCodeId = '-1';
          pdto.filedEnableStatus = true;
          this.loading = false;
        });

      }
    );
  }

  onchangeEnablePartner(dataValue: Event) {
    if (dataValue) {
      this.enablePartnerModel = true;
      this.enableTag = false;
    } else {
      this.enablePartnerModel = false;
      this.enableTag = true;
    }
  }

  enablePartnerSave() {
    this.loading = true;
    this.isLessOrMoreDate = '';
    this.enablePartnerMesg = '';
    // if (this.enablePartnerModel) {
    this.httpclientService.enablePartner(this.savedPartner, sessionStorage.getItem('globelUserId')).subscribe(
        data => {
          this.enablePartnerMesg = 'Partner is Successfully Enabled';
          this.enablePartnerModel = true;
          this.loading = false;
        }
      );
    // } else {
    //   this.enablePartnerMesg = 'Partner should be Enabled';
    //   this.loading = false;
    // }
  }

}
